import React from 'react';
import img1 from './image/section1.png';
import img2 from './image/section2.png';
import img3 from './image/section3.png';
import img4 from './image/section4.png';
import img5 from './image/section5.png';
import img6 from './image/section6.png';
import img7 from './image/section7.png';
import img8 from './image/section8.png';
import img9 from './image/section9.png';
import img10 from './image/section10.png';
import img11 from './image/example1.png';
import img12 from './image/example2.png';
import img13 from './image/example3.png';
import './Question.css';

// 問題を表示するパート
export default (props) => {
  const images = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
  ];

  const {
    content,
    logo
  } = props;

  const question = content.split('\n').map((m) => <p className='changingLine'>{m}</p>)

  return (
    <div className="question">
      <h4>{question}</h4>
      <img src={images[logo - 1]} className="Question-logo" alt="" />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/quiz/Question.js